import { ApiInstance } from '@src/services/api-instance';
import { HubCrmService } from './crm/hub-api-crm';
import { HubExtensionsService } from './extensions/hub-api-extensions';

export class HubV1Service {
  private readonly client: ApiInstance;

  public crm: HubCrmService;
  public extensions: HubExtensionsService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/v1`, client.getTimeout());

    this.crm = new HubCrmService(this.client);
    this.extensions = new HubExtensionsService(this.client);
  }
}
